// msmeindexDataHindi.js

// CLUSTER 1: FINANCIAL ARCHITECTURE & CAPITAL STABILITY
const baseQuestionsFinancialArchitecture = [

  // 🔹 वित्त तक सीमित पहुँच
  { id: "fa1q1", label: "हम ऋण या निवेशक समीक्षा के लिए अद्यतन वित्तीय विवरण तैयार रखते हैं।", pillar: "Finance" },
  { id: "fa1q2", label: "हमने पिछले 2 वर्षों में औपचारिक बैंक/NBFC ऋण के लिए आवेदन किया है।", pillar: "Finance" },
  { id: "fa1q3", label: "हम प्रमुख MSME ऋण योजनाओं की पात्रता शर्तों को समझते हैं।", pillar: "Finance" },
  { id: "fa1q4", label: "ऋणदाता से संपर्क करने से पहले हम नकदी प्रवाह का पूर्वानुमान तैयार करते हैं।", pillar: "Finance" },
  { id: "fa1q5", label: "हम एक संरचित क्रेडिट-रेडीनेस फाइल (दस्तावेज़, अनुपात, प्रक्षेपण) बनाए रखते हैं।", pillar: "Finance" },

  // 🔹 ऋण की उच्च लागत
  { id: "fa2q1", label: "हम ऋण लेने से पहले ब्याज दरों और शर्तों की तुलना करते हैं।", pillar: "Finance" },
  { id: "fa2q2", label: "हम ऋण की प्रभावी वार्षिक लागत (शुल्क और दंड सहित) की गणना करते हैं।", pillar: "Finance" },
  { id: "fa2q3", label: "कार्यशील पूंजी या टर्म लोन लेने से पहले हम ROI का आकलन करते हैं।", pillar: "Finance" },
  { id: "fa2q4", label: "हम अपनी क्रेडिट रेटिंग या बैंक प्रोफाइल सुधारने के लिए सक्रिय प्रयास करते हैं।", pillar: "Finance" },
  { id: "fa2q5", label: "बेहतर शर्तें उपलब्ध होने पर हम ऋण का पुनर्विनियोजन या पुनर्वित्त करते हैं।", pillar: "Finance" },

  // 🔹 भुगतान में देरी
  { id: "fa3q1", label: "हम देयकों की आयु (30/60/90 दिन) नियमित रूप से ट्रैक करते हैं।", pillar: "Finance" },
  { id: "fa3q2", label: "हम लिखित अनुबंध या चालान में स्पष्ट भुगतान शर्तें निर्धारित करते हैं।", pillar: "Finance" },
  { id: "fa3q3", label: "अतिदेय भुगतान के लिए हमारे पास संरचित अनुस्मारक/एस्केलेशन प्रक्रिया है।", pillar: "Finance" },
  { id: "fa3q4", label: "हम देयकों के प्रबंधन के लिए डिजिटल टूल या TReDS प्लेटफॉर्म का उपयोग करते हैं।", pillar: "Finance" },
  { id: "fa3q5", label: "भुगतान में देरी हमारे संचालन या वेतन पर शायद ही प्रभाव डालती है।", pillar: "Finance" },

  // 🔹 अनौपचारिक ऋण पर निर्भरता
  { id: "fa4q1", label: "हमारी कार्यशील पूंजी का 25% से कम हिस्सा अनौपचारिक स्रोतों से आता है।", pillar: "Finance" },
  { id: "fa4q2", label: "हमारा कम से कम एक औपचारिक वित्तीय संस्था से सक्रिय संबंध है।", pillar: "Finance" },
  { id: "fa4q3", label: "हम औपचारिक और अनौपचारिक ऋण की दीर्घकालिक लागत का अंतर समझते हैं।", pillar: "Finance" },
  { id: "fa4q4", label: "हम अनौपचारिक उधारी को धीरे-धीरे औपचारिक वित्त से बदलने की योजना रखते हैं।", pillar: "Finance" },
  { id: "fa4q5", label: "हम नियमित खर्चों के लिए आपातकालीन उच्च-ब्याज ऋण लेने से बचते हैं।", pillar: "Finance" },

  // 🔹 कमजोर वित्तीय साक्षरता
  { id: "fa5q1", label: "हम वार्षिक बजट तैयार करते हैं और समय-समय पर उसकी समीक्षा करते हैं।", pillar: "Finance" },
  { id: "fa5q2", label: "हम उत्पाद/सेवा अनुसार लाभ मार्जिन की निगरानी करते हैं।", pillar: "Finance" },
  { id: "fa5q3", label: "हम लागत-पत्रक बनाए रखते हैं और यूनिट इकॉनॉमिक्स समझते हैं।", pillar: "Finance" },
  { id: "fa5q4", label: "हम कम से कम अगले 3–6 महीनों का नकदी प्रवाह पूर्वानुमान तैयार करते हैं।", pillar: "Finance" },
  { id: "fa5q5", label: "वित्तीय निर्णय केवल अनुमान नहीं बल्कि डेटा पर आधारित होते हैं।", pillar: "Finance" },

];


// CLUSTER 2: GOVERNANCE & DECISION SYSTEMS
const baseQuestionsGovernanceSystems = [

  // 🔹 Business Professionalization Gaps
  { id: "gs1q1", label: "हमारे व्यवसाय में भूमिकाएँ और जिम्मेदारियाँ स्पष्ट रूप से परिभाषित और प्रलेखित हैं।", pillar: "Governance" },
  { id: "gs1q2", label: "मुख्य व्यावसायिक निर्णय केवल मालिक के निर्णय पर नहीं बल्कि संरचित समीक्षा प्रक्रिया से लिए जाते हैं।", pillar: "Governance" },
  { id: "gs1q3", label: "हम समय-समय पर प्रबंधन या रणनीति समीक्षा बैठकें आयोजित करते हैं।", pillar: "Governance" },
  { id: "gs1q4", label: "मुख्य प्रदर्शन संकेतक (KPI) परिभाषित हैं और नियमित रूप से मॉनिटर किए जाते हैं।", pillar: "Governance" },
  { id: "gs1q5", label: "यदि मालिक अस्थायी रूप से अनुपलब्ध हों तो भी व्यवसाय निरंतर चल सकता है।", pillar: "Governance" },

  // 🔹 Informality & Registration Issues
  { id: "gs2q1", label: "हमारा व्यवसाय लागू MSME/Udyam पंजीकरण के तहत औपचारिक रूप से पंजीकृत है।", pillar: "Governance" },
  { id: "gs2q2", label: "हम सभी आवश्यक लाइसेंस और पंजीकरण अद्यतन रखते हैं।", pillar: "Governance" },
  { id: "gs2q3", label: "हम GST, आयकर आदि वैधानिक रिटर्न समय पर दाखिल करते हैं।", pillar: "Governance" },
  { id: "gs2q4", label: "हम अनुबंध, कर्मचारियों और विक्रेताओं से संबंधित उचित दस्तावेज़ बनाए रखते हैं।", pillar: "Governance" },
  { id: "gs2q5", label: "हम पूर्णतः औपचारिक व्यवस्था में संचालन करने के लाभ समझते हैं।", pillar: "Governance" },

  // 🔹 Regulatory & Compliance Burden
  { id: "gs3q1", label: "हम अपने क्षेत्र पर लागू सभी नियामकीय आवश्यकताओं को ट्रैक करते हैं।", pillar: "Governance" },
  { id: "gs3q2", label: "अनुपालन जिम्मेदारियाँ किसी व्यक्ति या सलाहकार को स्पष्ट रूप से सौंपी गई हैं।", pillar: "Governance" },
  { id: "gs3q3", label: "हम फाइलिंग और नवीनीकरण के लिए अनुपालन कैलेंडर बनाए रखते हैं।", pillar: "Governance" },
  { id: "gs3q4", label: "हम निरीक्षण या ऑडिट के लिए पूर्व-तैयारी करते हैं।", pillar: "Governance" },
  { id: "gs3q5", label: "वित्तीय योजना बनाते समय अनुपालन लागत और जोखिम की समीक्षा की जाती है।", pillar: "Governance" },

  // 🔹 Lack of Awareness of Government Schemes
  { id: "gs4q1", label: "हम MSME से संबंधित नई सरकारी योजनाओं और नीतियों की सक्रिय निगरानी करते हैं।", pillar: "Governance" },
  { id: "gs4q2", label: "हमने पिछले 2 वर्षों में कम से कम एक सरकारी सहायता योजना के लिए आवेदन किया है।", pillar: "Governance" },
  { id: "gs4q3", label: "हम प्रमुख MSME योजनाओं (CGTMSE, TReDS, ZED आदि) की पात्रता शर्तों को समझते हैं।", pillar: "Governance" },
  { id: "gs4q4", label: "निवेश निर्णय लेने से पहले हम योजना के लाभों का मूल्यांकन करते हैं।", pillar: "Governance" },
  { id: "gs4q5", label: "सरकारी प्रोत्साहनों का लाभ लेने हेतु हमारे दस्तावेज़ तैयार रहते हैं।", pillar: "Governance" },

  // 🔹 Corruption & Uneven Policy Implementation Navigation
  { id: "gs5q1", label: "हम सभी नियामकीय और आधिकारिक कार्यों में पारदर्शी प्रक्रियाओं का पालन करते हैं।", pillar: "Governance" },
  { id: "gs5q2", label: "हम अनुपालन मामलों को हल करने के लिए अनौपचारिक भुगतान या शॉर्टकट से बचते हैं।", pillar: "Governance" },
  { id: "gs5q3", label: "आवश्यक होने पर हम नीति संबंधी शिकायतों को औपचारिक तंत्र के माध्यम से आगे बढ़ाते हैं।", pillar: "Governance" },
  { id: "gs5q4", label: "मनमानी प्रवर्तन से बचाव के लिए हम उचित दस्तावेज़ सुरक्षित रखते हैं।", pillar: "Governance" },
  { id: "gs5q5", label: "नियामकीय अनिश्चितता की स्थिति में हम पेशेवर या कानूनी सलाह लेते हैं।", pillar: "Governance" },

];


// CLUSTER 3: MARKET & COMPETITIVE POSITIONING
const baseQuestionsMarketPositioning = [

  // 🔹 Limited Market Access
  { id: "mp1q1", label: "हम कई चैनलों (ऑफलाइन, ऑनलाइन, वितरक, प्रत्यक्ष आदि) के माध्यम से बिक्री करते हैं।", pillar: "Market" },
  { id: "mp1q2", label: "हम प्रतिवर्ष नए भौगोलिक या सेक्टर बाजारों की खोज करते हैं।", pillar: "Market" },
  { id: "mp1q3", label: "हम व्यापार मेलों, B2B प्लेटफॉर्म या उद्योग नेटवर्क में भाग लेते हैं।", pillar: "Market" },
  { id: "mp1q4", label: "हम अपने उत्पाद/सेवा से संबंधित बाजार मांग रुझानों को ट्रैक करते हैं।", pillar: "Market" },
  { id: "mp1q5", label: "हमारी कुल आय का 30% से अधिक हिस्सा किसी एक ग्राहक से नहीं आता।", pillar: "Market" },

  // 🔹 Branding & Marketing Challenges
  { id: "mp2q1", label: "हमारी स्पष्ट ब्रांड पहचान और मूल्य प्रस्ताव परिभाषित है।", pillar: "Market" },
  { id: "mp2q2", label: "हम पेशेवर डिजिटल उपस्थिति (वेबसाइट, सोशल मीडिया आदि) बनाए रखते हैं।", pillar: "Market" },
  { id: "mp2q3", label: "हम विपणन और प्रचार के लिए निर्धारित बजट आवंटित करते हैं।", pillar: "Market" },
  { id: "mp2q4", label: "हम विपणन प्रदर्शन संकेतकों (लीड, कन्वर्जन आदि) को ट्रैक करते हैं।", pillar: "Market" },
  { id: "mp2q5", label: "हमारा ब्रांड संदेश सभी ग्राहक संपर्क बिंदुओं पर सुसंगत है।", pillar: "Market" },

  // 🔹 Sales & Customer Acquisition Inconsistency
  { id: "mp3q1", label: "हम संरचित बिक्री पाइपलाइन या CRM प्रणाली बनाए रखते हैं।", pillar: "Market" },
  { id: "mp3q2", label: "मासिक बिक्री लक्ष्य निर्धारित और समीक्षा किए जाते हैं।", pillar: "Market" },
  { id: "mp3q3", label: "ग्राहक अधिग्रहण रणनीतियाँ प्रलेखित और दोहराने योग्य हैं।", pillar: "Market" },
  { id: "mp3q4", label: "हम असफल सौदों या बिक्री में गिरावट के कारणों का विश्लेषण करते हैं।", pillar: "Market" },
  { id: "mp3q5", label: "हमारी आय अत्यधिक अस्थिर होने के बजाय पूर्वानुमेय है।", pillar: "Market" },

  // 🔹 Competitive Pressure
  { id: "mp4q1", label: "हम अपने प्रस्तावों को बड़े प्रतिस्पर्धियों से स्पष्ट रूप से अलग करते हैं।", pillar: "Market" },
  { id: "mp4q2", label: "हम मूल्य निर्धारण और प्रस्ताव की प्रतिस्पर्धियों से तुलना करते हैं।", pillar: "Market" },
  { id: "mp4q3", label: "प्रत्यक्ष प्रतिस्पर्धा कम करने हेतु हम विशिष्ट या विशेष बाजार पर ध्यान केंद्रित करते हैं।", pillar: "Market" },
  { id: "mp4q4", label: "हम मजबूत ग्राहक संबंध बनाए रखते हैं जिससे केवल मूल्य आधारित बदलाव कम हो।", pillar: "Market" },
  { id: "mp4q5", label: "हम प्रतिस्पर्धात्मकता बनाए रखने हेतु समय-समय पर नवाचार करते हैं।", pillar: "Market" },

  // 🔹 Regional Market Disparities
  { id: "mp5q1", label: "नए क्षेत्रों में विस्तार से पहले हम क्षेत्रीय मांग का आकलन करते हैं।", pillar: "Market" },
  { id: "mp5q2", label: "हम स्थानीय बाजार परिस्थितियों के अनुसार रणनीति समायोजित करते हैं।", pillar: "Market" },
  { id: "mp5q3", label: "हम भौगोलिक सीमाओं को पार करने हेतु डिजिटल प्लेटफॉर्म का उपयोग करते हैं।", pillar: "Market" },
  { id: "mp5q4", label: "हम राज्य-स्तरीय नीतियों या प्रोत्साहनों की निगरानी करते हैं।", pillar: "Market" },
  { id: "mp5q5", label: "हमारी आय किसी एक क्षेत्र पर अत्यधिक निर्भर नहीं है।", pillar: "Market" },

];

// CLUSTER 4: OPERATIONAL FLOW & PRODUCTIVITY SYSTEMS
const baseQuestionsOperationalFlow = [

  { id: "of1q1", label: "हम परिभाषित प्रणाली से नियमित रूप से इन्वेंट्री स्तर ट्रैक करते हैं।", pillar: "Operations" },
  { id: "of1q2", label: "हम धीमी गति या मृत स्टॉक का समय-समय पर विश्लेषण करते हैं।", pillar: "Operations" },
  { id: "of1q3", label: "मांग पैटर्न के आधार पर पुनः-आर्डर स्तर निर्धारित हैं।", pillar: "Operations" },
  { id: "of1q4", label: "निर्धारित अंतराल पर भौतिक स्टॉक का मिलान किया जाता है।", pillar: "Operations" },
  { id: "of1q5", label: "इन्वेंट्री होल्डिंग लागत की नियमित निगरानी की जाती है।", pillar: "Operations" },

  { id: "of2q1", label: "निर्भरता जोखिम कम करने हेतु हमारे पास कई आपूर्तिकर्ता विकल्प हैं।", pillar: "Operations" },
  { id: "of2q2", label: "डिलीवरी समयसीमा की समीक्षा की जाती है।", pillar: "Operations" },
  { id: "of2q3", label: "हम लॉजिस्टिक्स लागत को आय के प्रतिशत के रूप में मॉनिटर करते हैं।", pillar: "Operations" },
  { id: "of2q4", label: "आपूर्ति व्यवधानों का दस्तावेजीकरण और विश्लेषण किया जाता है।", pillar: "Operations" },
  { id: "of2q5", label: "हम सुरक्षा स्टॉक या वैकल्पिक स्रोत योजना बनाए रखते हैं।", pillar: "Operations" },

  { id: "of3q1", label: "बिजली, इंटरनेट या उपयोगिता बाधाएँ शायद ही संचालन को प्रभावित करती हैं।", pillar: "Operations" },
  { id: "of3q2", label: "महत्वपूर्ण अवसंरचना के लिए बैकअप व्यवस्था है।", pillar: "Operations" },
  { id: "of3q3", label: "उत्पादन क्षमता की मांग पूर्वानुमान से समीक्षा की जाती है।", pillar: "Operations" },
  { id: "of3q4", label: "हम उपकरण या सुविधाओं के उन्नयन में समय-समय पर निवेश करते हैं।", pillar: "Operations" },
  { id: "of3q5", label: "रणनीतिक योजना में अवसंरचना सीमाओं पर विचार किया जाता है।", pillar: "Operations" },

  { id: "of4q1", label: "बड़े निवेश से पहले नई तकनीकों का मूल्यांकन किया जाता है।", pillar: "Operations" },
  { id: "of4q2", label: "नई प्रणाली लागू होने पर कर्मचारियों को प्रशिक्षण दिया जाता है।", pillar: "Operations" },
  { id: "of4q3", label: "नई तकनीक अपनाने से पहले ROI की गणना की जाती है।", pillar: "Operations" },
  { id: "of4q4", label: "परिवर्तन प्रबंधन के माध्यम से तकनीकी प्रतिरोध को संबोधित किया जाता है।", pillar: "Operations" },
  { id: "of4q5", label: "तकनीकी उन्नयन दीर्घकालिक लक्ष्यों से संरेखित है।", pillar: "Operations" },

  { id: "of5q1", label: "हम ERP/MIS प्रणाली से वित्त, इन्वेंट्री और बिक्री डेटा एकीकृत करते हैं।", pillar: "Operations" },
  { id: "of5q2", label: "डिजिटल रिपोर्ट निर्णय लेने में उपयोग की जाती हैं।", pillar: "Operations" },
  { id: "of5q3", label: "विभागों में डेटा प्रविष्टि समय पर और सटीक होती है।", pillar: "Operations" },
  { id: "of5q4", label: "हम KPI मॉनिटर करने हेतु डैशबोर्ड या विश्लेषण उपकरण का उपयोग करते हैं।", pillar: "Operations" },
  { id: "of5q5", label: "सिस्टम-जनित अंतर्दृष्टि से लागत या दक्षता सुधार किए जाते हैं।", pillar: "Operations" },

];

// CLUSTER 5: STRATEGIC RESILIENCE & FUTURE READINESS
const baseQuestionsStrategicResilience = [

  { id: "sr1q1", label: "महत्वपूर्ण पदों के लिए कुशल कर्मचारियों की भर्ती में कठिनाई आती है।", pillar: "Strategy" },
  { id: "sr1q2", label: "प्रत्येक प्रमुख पद के लिए कौशल आवश्यकताएँ परिभाषित हैं।", pillar: "Strategy" },
  { id: "sr1q3", label: "आवश्यक होने पर हम प्रशिक्षण संस्थानों से सहयोग करते हैं।", pillar: "Strategy" },
  { id: "sr1q4", label: "संगठन में कौशल अंतर का नियमित आकलन किया जाता है।", pillar: "Strategy" },
  { id: "sr1q5", label: "हम कर्मचारियों को अपस्किल करने में निवेश करते हैं।", pillar: "Strategy" },

  { id: "sr2q1", label: "कर्मचारी पलायन संचालन निरंतरता को प्रभावित करता है।", pillar: "Strategy" },
  { id: "sr2q2", label: "कर्मचारियों के लिए करियर प्रगति मार्ग परिभाषित हैं।", pillar: "Strategy" },
  { id: "sr2q3", label: "वेतन संरचना बाजार मानकों के अनुसार बेंचमार्क की जाती है।", pillar: "Strategy" },
  { id: "sr2q4", label: "हम समय-समय पर कर्मचारी प्रतिक्रिया सर्वे करते हैं।", pillar: "Strategy" },
  { id: "sr2q5", label: "प्रबंधन समीक्षा में प्रतिधारण जोखिम पर चर्चा की जाती है।", pillar: "Strategy" },

  { id: "sr3q1", label: "हम लागू होने पर उद्योग-प्रासंगिक प्रमाणन बनाए रखते हैं।", pillar: "Strategy" },
  { id: "sr3q2", label: "अनुपालन आवश्यकताओं की समय-समय पर समीक्षा की जाती है।", pillar: "Strategy" },
  { id: "sr3q3", label: "गुणवत्ता ऑडिट आंतरिक या बाहरी रूप से किए जाते हैं।", pillar: "Strategy" },
  { id: "sr3q4", label: "गैर-अनुपालन जोखिमों को दस्तावेजीकृत और शीघ्र सुधारा जाता है।", pillar: "Strategy" },
  { id: "sr3q5", label: "प्रमाणनों का उपयोग बाजार स्थिति मजबूत करने हेतु किया जाता है।", pillar: "Strategy" },

  { id: "sr4q1", label: "हम ऊर्जा, पानी या संसाधन खपत को ट्रैक करते हैं।", pillar: "Strategy" },
  { id: "sr4q2", label: "अपशिष्ट कम करने या रीसाइक्लिंग पहल लागू हैं।", pillar: "Strategy" },
  { id: "sr4q3", label: "हम पर्यावरण-अनुकूल विकल्पों का मूल्यांकन करते हैं।", pillar: "Strategy" },
  { id: "sr4q4", label: "सततता अनुपालन आवश्यकताओं की निगरानी की जाती है।", pillar: "Strategy" },
  { id: "sr4q5", label: "हरित परिवर्तन को दीर्घकालिक योजना में शामिल किया जाता है।", pillar: "Strategy" },

  { id: "sr5q1", label: "हम अपने व्यवसाय से संबंधित वस्तु मूल्य उतार-चढ़ाव की निगरानी करते हैं।", pillar: "Strategy" },
  { id: "sr5q2", label: "हम नीति या व्यापार परिवर्तनों के प्रभाव का आकलन करते हैं।", pillar: "Strategy" },
  { id: "sr5q3", label: "राजस्व विविधीकरण से एक उत्पाद या बाजार पर निर्भरता कम है।", pillar: "Strategy" },
  { id: "sr5q4", label: "आर्थिक मंदी से निपटने हेतु हम वित्तीय बफर बनाए रखते हैं।", pillar: "Strategy" },
  { id: "sr5q5", label: "बड़े बाहरी जोखिमों हेतु परिदृश्य योजना की जाती है।", pillar: "Strategy" },

];
export const allSets = {
  1: baseQuestionsFinancialArchitecture,
  2: baseQuestionsGovernanceSystems,
  3: baseQuestionsMarketPositioning,
  4: baseQuestionsOperationalFlow,
  5: baseQuestionsStrategicResilience,
};
